<template>
  <view-page
    baseRoute="facilities"
    :entity='entity'
    :button-access="componentAccess"
    :model-entity="modelEntity"
    :disable-buttons="hasPendingChanges"
  >
    <template v-slot="{ model }">
      <vs-alert color="warning" title="Deleted Record" v-if="model.IsDeleted" class="mb-4">
        <span>You are viewing the record for a deleted facility</span>
      </vs-alert>
      
      <vs-alert color="warning" title="Pending Changes" v-if="hasPendingChanges" class="mb-4">
        <span>This facility has a pending change request that must be approved or rejected before any modifications can be made.</span>
      </vs-alert>
      
      <facility-form
        v-if="model"
        :readonly="readonly"
        :value="model"
        @input="model = $event"
        card-title="Details"
      />
    </template>

    <template v-slot:extra-button="{ model }">
      <vs-button
        v-if="model && componentAccess.canPublish.access && !hasPendingChanges"
        class="mt-2 ml-4"
        color="light"
        @click="openPublishAlert(model)"
      >
        {{ model.IsPublished ? "Unpublish" : "Publish" }}
      </vs-button>
      <vs-button
          v-if="model && componentAccess.canEnable.access && !hasPendingChanges"
          class="mt-2 ml-4"
          color="light"
          @click="openEnableAlert(model)"
      >
        {{ model.IsEnabled ? "Deactivate" : "Activate" }}
      </vs-button>
    </template>
  </view-page>
</template>

<script>
import ViewPage from '@/views/components/Views/ViewPage';
import FacilityForm from '@/views/pages/facilities/FacilityForm';
import NotificationMixin from '@/components/mixins/NotificationMixin';
import EnablePublishMixin from '../../../components/mixins/EnablePublishMixin';

export default {
  name: 'FacilityView',
  components: {
    FacilityForm,
    ViewPage
  },
  mixins: [NotificationMixin, EnablePublishMixin],
  data() {
    return {
      model: null,
      entity: 'Facility',
      readonly: true,
      hasPendingChanges: false,
      modelEntity: this.$api.facilities,
      componentAccess: {
        canEdit: {
          route: 'facilities.edit',
          access: false
        },
        canDelete: {
          route: 'facilities.delete',
          access: false
        },
        canRestore: {
          route: 'facilities.restore',
          access: false
        },
        canPublish: {
          route: 'facilities.publish',
          access: false
        },
        canEnable: {
          route: 'facilities.publish',
          access: false
        }
      }
    };
  },
  async mounted() {
    await this.checkPendingChanges();
  },
  methods: {
    async checkPendingChanges() {
      try {
        const facilityId = this.$route.params.id;
        if (facilityId) {
          const response = await this.$api.facilities.hasPendingChanges(facilityId);
          this.hasPendingChanges = response.data.hasPendingChanges;
        }
      } catch (error) {
        console.error('Error checking pending changes:', error);
        this.hasPendingChanges = false;
      }
    }
  },
  watch: {
    '$route.params.id': {
      handler: 'checkPendingChanges',
      immediate: true
    }
  }
};
</script>

<style scoped>
</style>
